<template>
    <router-view
        :loaded="loader.loaded"
        :timelineConfigurations="timelineConfigurations"
        :profileContent="profileContent"
        @start-loader="StartLoader(loadContent)"
        @stop-loader="StopLoader()"
        @timeline-configurations="TimelineConfigurations($event)"
        @sub-navigation-navigate="SubNavigationNavigate($event)"
    />
    <Loader :loader="loader"/>
    <Footer :show="ShowFooter()" :contentLoaded="this.timelineConfigurations.enabled"/>
    <div id="platform">
        <div id="desktop" class="hide"></div>
        <div id="mobile" class="hide"></div>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import Footer from "@/components/Template/Footer.vue";
import { timelineModel } from "@/models";
import {
    CONFIG,
    profile
} from "@/assets/JS/Config.js";
import { MASTER } from "@/assets/JS/Master.js";

export default {
    name: "App",
    components: {
        Loader,
        Footer
    },
    data: () => ({
        loader: {
            show: false,
            content: "",
            loaded: false,
            type: ""
        },
        ...timelineModel(CONFIG),
        timelineConfigurations: {},
        profileContent: {
            content: profile.defaultLandingPage,
            backgroundImage: ""
        },
        platform: { mobile: false }
    }),
    methods: {
        StartLoader: function(loadContent) {
            this.loader = {
                show: true,
                content: loadContent,
                loaded: false,
                type: "Logo"
            };
        },
        StopLoader: function() {
            this.loader.show = false;
            this.loader.loaded = true;
        },
        TimelineConfigurations: function(configurations) {
            this.timelineConfigurations = configurations;
        },
        ShowFooter: function() {
            return this.$route.fullPath === "/" ? this.loader.loaded : true;
        },
        SubNavigationNavigate: function(subNavigationItem) {
            if (this.$route.fullPath === "/") {
                this.profileContent.content = subNavigationItem;
            } else {
                const route = this.$router.getRoutes().filter(r => r.name === "Main")[0];
                route.meta.profileContent.content = subNavigationItem;
                this.$router.push({
                    name: "Main",
                    meta: route.meta
                });
            }
        }
    },
    mounted: function() {
        MASTER.Platform.Construct();
        this.platform.mobile = MASTER.Platform._mobile;

        // Set profile background image
        const randomIndex = Math.floor(Math.random() * profile.featureImages.length);
        const image = profile.featureImages[randomIndex];
        let backgroundImageSource = "";
        if (!this.platform.mobile) {
            backgroundImageSource = require(`@/assets/Images/ProfileFeatures/${image}`);
        } else {
            backgroundImageSource = require(`@/assets/Images/M/ProfileFeatures/${image}`);
        }
        this.profileContent.backgroundImage = backgroundImageSource;

    }
};
</script>